<template>
  <div class="report" v-if="load">
    <report-menu v-model="date"></report-menu>
    <div class="main">
      <h2 class="main-title">Підсумки обслуговування</h2>
      <div class="balance">
        <div class="block">
          <div v-tooltip.top-center="'Сформувати рахунок'" class="cart cart-link">
            <span>Залишок (&#8372;): &nbsp;</span><b>{{balanceTurnover.restOut | toCurrency}}</b>
            <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.5 9L0.73686 0.75L10.2631 0.75L5.5 9Z"/>
            </svg>
          </div>
          <div class="cart">
            <span>Вхідний залишок на {{date[0] | formatOnlyDate}} (&#8372;): &nbsp;</span><b>{{balanceTurnover.restIn | toCurrency}}</b>
          </div>
          <div v-tooltip.top-center="'Історія оплат'" class="cart cart-link">
            <span>Всього оплат (&#8372;): &nbsp;</span><b>{{balanceTurnover.payment | toCurrency}}</b>
            <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.5 9L0.73686 0.75L10.2631 0.75L5.5 9Z"/>
            </svg>
          </div>
          <div v-tooltip.top-center="'Деталі обслуговування'" class="cart cart-link">
            <span>Всього обслуговано(&#8372;): &nbsp;</span><b>{{balanceTurnover.service | toCurrency}}</b>
            <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.5 9L0.73686 0.75L10.2631 0.75L5.5 9Z"/>
            </svg>
          </div>
        </div>
      </div>
      <div class="row-right">
        <div class="form_radio_btn">
          <input type="radio" id="one" value="table" v-model="typeReport">
          <label for="one">Таблиця</label>
        </div>
        <div class="form_radio_btn">
          <input type="radio" id="two" value="grafic" v-model="typeReport">
          <label for="two">ГРАФІК</label>
        </div>
      </div>
      <div class="grafic" v-if="typeReport!=='table'" >
        <line-chart :width="300" :height="300" :radius="10" :cutout="8" :chart-data="datacollection" :options="chartOptions" ></line-chart>
        <button @click="fillData()">Randomize</button>
      </div>
      <section v-if="typeReport==='table'">
        <header>
          <div class="col-td">Номенклатура</div>
          <div class="col-td">Кількість</div>
          <div class="col-td">Ціна</div>
          <div class="col-td">СУМА (₴)</div>
        </header>
        <div class="table-row first-row">
          <div class="col-td">Вього</div>
          <div class="col-td">{{ totalTransactionsByGood.totalAmount}}</div>
          <div class="col-td">{{ totalTransactionsByGood.avgPrice | toCurrency }}</div>
          <div class="col-td">{{totalTransactionsByGood.totalSum | toCurrency }}</div>
        </div>

        <template  v-for="(tr, i) in transactionsByGood" >
          <div class="table-row" :key="i">
            <div class="col-td desktop" style="width: 10%" >{{tr.nameGood}}</div>
            <div class="col-td desktop"  style="width: 10%">{{tr.amount }}</div>
            <div class="col-td desktop"  style="width: 10%">{{tr.price | toCurrency }}</div>
            <div class="col-td desktop"  style="width: 10%">{{tr.summa | toCurrency}}</div>
          </div>
        </template>
      </section>
    </div>
  </div>
</template>
<script>
import LineChart from '../lib/LineChart'
import ReportMenu from '../components/ReportMenu'
import  moment from "moment";
moment.defineLocale('uk', null)
export default {
  name: 'Reports',
  components: {
    ReportMenu,
    LineChart
  },
  watch: {
    date: function (){
      this.load = false
      this.getData()
    }
  },
  data() {
    return {
      searchText: 'Test',
      chartOptions: {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
      },
      datacollection: null,
      load: false,
      typeReport: "table",
      balanceTurnover: null,
      transactionsByGood: [],
      totalTransactionsByGood: {},
      highlighted: {},
      date: [new Date(moment().format('YYYY, MM, 01') ), new Date() ],
    }
  },
  created() {
    this.getData()
  },
  mounted () {
    this.fillData()
  },
  methods: {
    fillData () {
      this.datacollection = {
        labels: ['Газ', 'A-95', 'A-92'],
        datasets: [{
          label: 'My First Dataset',
          data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt()],
          backgroundColor: [
        'rgb(255, 99, 132)',
        'rgb(54, 162, 235)',
        'rgb(255, 205, 86)'
      ],
          hoverOffset: 4}
        ]
      }
    },
    getRandomInt () {
      return Math.floor(Math.random() * (5 + 1)) + 5
    },
    getData: function (){
      this.axios.all([
        this.axios.get('/userservice/v1/User/balance-turnover', {params: {begDate: moment(this.date[0]).format('YYYY-MM-DD') + ' 00:00:00', endDate: moment(this.date[1]).format('YYYY-MM-DD') + ' 00:00:00'}}),
        this.axios.get('/userservice/v1/User/transactions-by-good', {params: {begDate: moment(this.date[0]).format('YYYY-MM-DD') + ' 00:00:00', endDate: moment(this.date[1]).format('YYYY-MM-DD') + ' 00:00:00'}}),
        //this.axios.get('https://map.svitpro.com.ua/messages-api')
      ]).then(
          this.axios.spread((balanceTurnover, transactionsByGood) => {
            this.balanceTurnover = balanceTurnover.data
            this.transactionsByGood = transactionsByGood.data.data
            this.totalTransactionsByGood =  transactionsByGood.data.total
            //  this.info = info.data
          })
      )
          .catch(error => {
            console.log('error_get_data');
            console.log(error);
            this.errored = true;
          })
          .finally(() => (
              this.load = true)
          )
    },
  }
}
</script>
<style>
.form_radio_btn {
  display: inline-block;
  margin-right: 10px;
}
.form_radio_btn input[type=radio] {
  display: none;
}
.form_radio_btn label {
  display: inline-block;
  cursor: pointer;
  padding: 10px 20px;
  line-height: 34px;
  border: none;
  border-radius: 20px;
  user-select: none;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 19px;
  /* or 146% */
  text-align: center;
  text-transform: uppercase;
  font-feature-settings: 'cpsp' on;
  color: #222160;
  background: #E5E5E5;
}

/* Checked */
.form_radio_btn input[type=radio]:checked + label {
  background: #222160;
  color: #E5E5E5;
}

/* Hover */
.form_radio_btn label:hover {
  color: #666;
}
.grafic {
  height: 335px;
  background: #F5F5F5;
  margin-top: 30px;
}
.row-right {
  display: flex;
  justify-content: end;
}


.right-inner-addon span.text{
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 19px;
/* or 146% */
  font-feature-settings: 'cpsp' on;
  color: #222160;
  margin: 5px;
}
.report .main {
  //padding-top: 6em;
  margin-left: 25px;
}
 .report {
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   width: 80%;
   align-self: center;
   justify-self: center;
 }
</style>